import {Base} from "@/api/Base"

export class PaymentEdit extends Base {
    path = "payment/edit"
}